import { styled } from '@mui/system'
import Typography from '@mui/material/Typography'

const Text = styled(Typography)(({ theme }) => ({
	color: theme.palette.primary.main,
	fontFamily: 'Gilroy-Medium, sans-serif',
	fontSize: '1.25rem',
	textAlign: 'center',
}))

export { Text }
